import { ParentalControlStep } from '@enums/profile.enum'
import { DocumentData } from 'firebase/firestore'
import { ProfileImagesData } from 'sdk/services/config/types/config'
import { UserProfile } from 'sdk/services/storage/profiles/types/profilesManager'

export const SET_PROFILE_BUTTON_FOCUS = 'SET_PROFILE_BUTTON_FOCUS'
export const SET_PROFILES = 'SET_PROFILES'
export const SET_PARENTAL_ACTION = 'SET_PARENTAL_ACTION'
export const SET_PARENTAL_CONTROL = 'SET_PARENTAL_CONTROL'
export const SET_CONTENT_CLASSIFICATION = 'SET_CONTENT_CLASSIFICATION'
export const SET_PIN = 'SET_PIN'
export const SET_PARENTAL_STATE_SNAPSHOT = 'SET_PARENTAL_STATE_SNAPSHOT'
export const SET_PROFILE_NAME = 'SET_PROFILE_NAME'
export const SET_PROFILE_LANG = 'SET_PROFILE_LANG'
export const SET_PROFILE_PHOTO = 'SET_PROFILE_PHOTO'

export const setProfileButtonFocus = (focusedButton: string) => ({
  type: SET_PROFILE_BUTTON_FOCUS,
  payload: {
    focusedButton,
  },
})

export const setProfiles = (profiles: UserProfile[] | DocumentData) => ({
  type: SET_PROFILES,
  payload: {
    profiles,
  },
})

export const setParentalAction = (parentalAction: ParentalControlStep | null) => ({
  type: SET_PARENTAL_ACTION,
  payload: {
    parentalAction,
  },
})

export const setParentalControl = (value: null | boolean) => ({
  type: SET_PARENTAL_CONTROL,
  payload: {
    value,
  },
})

export const setProfileContentClassification = (contentClassification: string | null) => ({
  type: SET_CONTENT_CLASSIFICATION,
  payload: {
    contentClassification,
  },
})

export const setProfilePIN = (pin: string | null) => ({
  type: SET_PIN,
  payload: {
    pin,
  },
})

export const setProfileName = (name: string) => ({
  type: SET_PROFILE_NAME,
  payload: {
    name,
  },
})

export const setProfileLang = (lang: string) => ({
  type: SET_PROFILE_LANG,
  payload: {
    lang,
  },
})

export const setProfilePhoto = (photo: ProfileImagesData | null) => ({
  type: SET_PROFILE_PHOTO,
  payload: {
    photo,
  },
})

export const setParentalStateSnapshot = (
  snapshot: {
    parentalControl: null | boolean
    contentClassification: string
    pin: string | number | null
  } | null,
) => ({
  type: SET_PARENTAL_STATE_SNAPSHOT,
  payload: {
    snapshot,
  },
})
